import { render } from "./cc-diners-icon.svg?vue&type=template&id=080f0262"
import script from "./cc-diners-icon.svg?vue&type=script&lang=js"
export * from "./cc-diners-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3551/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__